import {
  httpDecideAddressVerification,
  httpFetchAddressVerificationReviews,
} from "api/support/user";
import AddressVerificationReviews from "components/compliance/AddressVerificationReviews";
import SupportSidebar from "components/layout/SupportSidebar";

const SupportAddressVerificationReviews = () => (
  <AddressVerificationReviews
    reviewerType="support"
    Sidebar={SupportSidebar}
    fetchReviews={httpFetchAddressVerificationReviews}
    decideReview={httpDecideAddressVerification}
  />
);

export default SupportAddressVerificationReviews;
